import { Component } from '@angular/core';
import { PageHeaderComponent } from "../page-header/page-header.component";
import { ImportsCsvFormComponent } from "./pages/imports-csv-form/imports-csv-form.component";
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-imports-csv',
    templateUrl: './imports-csv.component.html',
    styleUrls: ['./imports-csv.component.less'],
    imports: [
        PageHeaderComponent,
        ImportsCsvFormComponent,
        TranslateModule
    ]
})
export class ImportsCSVComponent { }
